import Vue from 'vue';
import loadingDirective from './loading.directive'

Vue.directive('loading', loadingDirective);
